<template>
  <section class="section" v-if="!loading && products !== null">

    <h2 v-if="category !== null" style="margin-bottom: 0;">{{ niceCategory }}</h2>

    <div v-if="category !== null" style="text-align: center; font-size: 12px; margin-bottom: 10px;">*Pricing includes delivery and taxes</div>

    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-one-third is-one-quarter-desktop" :key="product.id" v-for="product in products" @click="onProductSelect(product)">
          <card class="category-items" hoverable>
            <div class="card-image" v-if="product.imageId !== null">
              <div class="image is-square">
                <img :src="BASE_URL + '/images/' + product.imageId + '/large'">
              </div>
            </div>
            <div class="card-content">
              <h3>{{product.name}}</h3>
              <h4 class="product-price"> ${{ (product.price / 100).toFixed(2) }} </h4>
            </div>
          </card>
        </div>
      </div>
    </div>
  </section>
  <loader v-else></loader>
</template>

<script>
import Loader from './Loader';
import Card from './Card';
import { BASE_URL } from '../http';
import Breadcrumb from './Breadcrumb.vue';

export default {
  components: {
    Card,
    Loader,
    Breadcrumb,
  },

  name: 'shop-category-view',

  data() {
    return {
      BASE_URL,
      category: null,
    };
  },

  created() {
    this.category = this.$route.params.category;

    // console.log(this.category);

    this.$store.commit('progress/start');

    this.$store.dispatch('products/load', { category: this.category }).then(() => this.$store.commit('progress/stop'));
  },

  methods: {
    onProductSelect(product) {
      this.$router.push({
        name: 'ProductView',
        params: {
          category: this.$route.params.category.toLowerCase().replace(new RegExp(' ', 'g'), '-'),
          product_name: product.name.toLowerCase().replace(new RegExp(' ', 'g'), '-'),
          ecat: this.$route.params.ecat,
        },
      });
    },
  },

  computed: {
    niceCategory() {
      return this.category.replace(new RegExp('-', 'g'), ' ');
    },
    loading() {
      return this.$store.state.products.loading;
    },

    products() {
      return this.$store.state.products.products;
    },
    crumbs() {
      return [
        { text: this.$route.params.ecat.toUpperCase(), l: `/${this.$route.params.ecat}` },
        {
          text: this.$route.params.category.toUpperCase().replace(new RegExp('-', 'g'), ' '),
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ShopCategoryView.vue